export const sortAddressConfig = (addressConfig) => {
  addressConfig = addressConfig.sort((a, b) => {
    return a.displayOrder - b.displayOrder
  })
}

/**
 * Returns the formatted address
 * @param {Object} addrObj Object containing address fields, should contain atleast Landmark and Address field
 * @param {Object} addrConfig Object containing address configurations
 * @returns format address of string type
 */
export const getFormattedAddress = (addrObj, addrConfig) => {
  addrConfig = sortAddressConfig(addrConfig)
  let addrValues = []
  addrConfig.forEach((configItem) => {
    const value = addrObj[configItem.keyName]
    if (value && value?.length > 0) {
      addrValues.push(value)
    }
  })

  //If user landmark and landmark exists, then delete landmark
  if (!!addrObj['landmark'] && !!addrObj['userLandmark']) {
    addrValues.splice(0, 1)
  }

  return addrValues.reduce((resultAddr, value, index) => {
    return resultAddr + value + (index < addrValues.length - 1 ? ', ' : '')
  }, '')
}

export const capitalize = (str) => {
  return (str && str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()) || ''
}

export const toCamelCase = (o) => {
  var newO, origKey, newKey, value
  if (o instanceof Array) {
    return o.map(function (value) {
      if (typeof value === 'object') {
        value = toCamelCase(value)
      }
      return value
    })
  } else {
    newO = {}
    for (origKey in o) {
      if (o.hasOwnProperty(origKey)) {
        const characterAtSecondPosition = origKey.charAt(1)
        if (!characterAtSecondPosition || characterAtSecondPosition !== characterAtSecondPosition.toUpperCase()) {
          newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString()
          value = o[origKey]
          if (value instanceof Array || (value !== null && value.constructor === Object)) {
            value = toCamelCase(value)
          }
          newO[newKey] = value
        } else {
          newO[origKey] = o[origKey]
        }
      }
    }
  }
  return newO
}

export const toCamelCaseString = (w) => {
  return w[0].toLowerCase() + w.slice(1)
}

export const toPascalCase = (w) => {
  return w[0].toUpperCase() + w.slice(1)
}
